/**
 * Calendar API
 *
 * Functions for managing personal calendar feed.
 * Issue #941: Club iCal calendar feed (subscribable)
 * Issue #943: Feed mode filter (all vs RSVP only)
 */

import { apiGet, apiPost, apiPatch } from '../api';

// Feed mode type (#943)
export type CalendarFeedMode = 'all' | 'rsvp_only';

export interface CalendarFeedResponse {
  calendar_feed: {
    url: string;
    token: string;
    feed_mode: CalendarFeedMode;
  };
}

export interface UpdateFeedModeResponse {
  success: boolean;
  feed_mode: CalendarFeedMode;
}

/**
 * Get or create the user's calendar feed URL
 */
export async function getCalendarFeed(): Promise<CalendarFeedResponse> {
  return apiGet<CalendarFeedResponse>('/calendar/token');
}

/**
 * Regenerate the calendar feed URL (invalidates old URL)
 */
export async function regenerateCalendarFeed(): Promise<CalendarFeedResponse> {
  return apiPost<CalendarFeedResponse>('/calendar/token/regenerate', {});
}

/**
 * Update calendar feed mode (#943)
 */
export async function updateCalendarFeedMode(
  feedMode: CalendarFeedMode
): Promise<UpdateFeedModeResponse> {
  return apiPatch<UpdateFeedModeResponse>('/calendar/settings', { feed_mode: feedMode });
}

// ============================================================================
// Club Calendar API (#1058)
// ============================================================================

export interface ClubCalendarFeedResponse {
  calendar_feed: {
    url: string;
    token: string;
    club_name: string;
  };
}

/**
 * Get or create a club's calendar feed URL
 * Requires leader+ permission
 */
export async function getClubCalendarFeed(clubSlug: string): Promise<ClubCalendarFeedResponse> {
  return apiGet<ClubCalendarFeedResponse>(`/clubs/${clubSlug}/calendar/token`);
}

/**
 * Regenerate a club's calendar feed URL (invalidates old URL)
 * Requires leader+ permission
 */
export async function regenerateClubCalendarFeed(clubSlug: string): Promise<ClubCalendarFeedResponse> {
  return apiPost<ClubCalendarFeedResponse>(`/clubs/${clubSlug}/calendar/token/regenerate`, {});
}
